export default __webpack_public_path__ + "static/media/about-benefits-profile-page.eb6ef6bf.jpg";